import * as busca from '@/api/busca'
const state = {
}

const mutations = {}

const actions = {
  async busca (context, payload) {
    return busca.hiscon(payload)
  },
  async buscaHide (context, payload) {
    return busca.hiscon(payload, false)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/consultas/hiscon.js